// Random int
export function randomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Random float
export function randomFloat(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

// Clamp
export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

// distance
export function distance(x1: number, y1: number, x2: number, y2: number) {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}
